import { useState } from "react";

import { useEditCompanyMutation } from "@modules/companies/services/mutations";
import { ActiveCompanySwitchProps } from "./types";

export function useActiveCompanySwitch({ id, value }: ActiveCompanySwitchProps) {
  const [isActive, setIsActive] = useState(value);

  const { mutateAsync, isPending } = useEditCompanyMutation(id);

  const toggle = async () => {
    await mutateAsync({
      active: !isActive,
    });

    setIsActive((prev) => !prev);
  }

  return { isActive, isPending, toggle };
}
